module.exports = __webpack_public_path__ + "static/media/trolleybus.8076520e.svg";